import { Elide } from "./elide";

export function ElidedCell({ getValue }) {
    const value = getValue();
    return <Elide title={value}>{value}</Elide>;
}
